import { render, staticRenderFns } from "./safe-card.vue?vue&type=template&id=bbcca86e&"
import script from "./safe-card.vue?vue&type=script&lang=js&"
export * from "./safe-card.vue?vue&type=script&lang=js&"
import style0 from "./safe-card.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports